<template>
  <div>
    <div class="upload-box" :style="{ width: uploadBoxWidth }">
      <div class="box-type">素材</div>
      <el-upload
        v-for="(item, index) in mediaForm.resolutionList"
        ref="uploader"
        action="#"
        list-type="picture-card"
        :disabled="item.disabled"
        :key="index"
        :accept="item.accept"
        :class="[
          'res-uploader',
          item.mediaIcon ? 'exist-img' : '',
          item.status === 'uploading' ? 'uploading' : '',
          item.disabled ? 'is-disabled' : ''
        ]"
        :limit="1"
        :file-list="item.fileList"
        :http-request="(file) => { uploadFile(file, item, index) }"
        :before-upload="(file) => { return beforeUploadFile(file, item, index) }"
      >
        <div slot="file" class="image-wrapper">
          <div class="image-box">
            <div v-if="item.url">
              <el-image :src="item.url" fit="contain">
                <div slot="error" class="error-icon">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <div class="image-desc">{{ item.width }} * {{ item.height }}</div>
            </div>
            <span class="el-upload-list__item-actions" :style="item.status === 'uploading' ? 'opacity:1' : ''">
              <span v-if="item.status === 'success'" class="el-upload-list__item-delete" @click="removeFile(item, index)">
                <i class="el-icon-delete"></i>
              </span>
              <span v-if="item.status === 'success'" class="el-upload-list__item-delete" @click="handleReUpload(item, index)">
                <i class="el-icon-upload" style="font-size:22px"></i>
              </span>
              <el-progress
                v-if="item.status === 'uploading'"
                type="circle"
                color="#f78400"
                text-color="#fff"
                :width="100"
                :percentage="item.percentage"
              ></el-progress>
            </span>
          </div>
        </div>
        <div slot="default" class="upload-btn">
          <i class="el-icon el-icon-plus"></i>
          <p>{{ item.fileTips }}</p>
        </div>
      </el-upload>
    </div>
    <div class="extra-upload">
      <!-- 弹窗引导图 -->
      <el-form-item v-if="needGuideImg" label-width="120px">
        <GuideImgUploader
          :mediaItem="mediaForm"
          :guideImgConfig="guideImgConfig"
          :spaceId="mediaForm.spaceId"
          :disabled="formDisabled"
        />
      </el-form-item>
      <!-- 封面图 -->
      <el-form-item
        v-if="needCoverImg"
        label-width="120px"
        prop="minIcon"
        :rules="[{ required: true, message: '请上传素材封面图' }]"
      >
        <CoverImgUploader
          :mediaItem="mediaForm"
          :coverImgConfig="coverImgConfig"
          :spaceId="mediaForm.spaceId"
          :disabled="formDisabled"
        />
      </el-form-item>
      <!-- 背景图 -->
      <el-form-item
        v-if="showBgImage"
        label-width="0"
        class="min-icon-item"
      >
        <BgImageUploader
          :mediaItem="mediaForm"
          :bgImageConfig="bgImageConfig"
          :spaceId="mediaForm.spaceId"
          :disabled="formDisabled"
        />
      </el-form-item>
    </div>
  </div>
</template>

<script>
import GuideImgUploader from './GuideImgUploader.vue'
import CoverImgUploader from './CoverImgUploader.vue'
import { getImgResolution } from '@/utils/util'
import SparkMD5 from 'spark-md5'
import BgImageUploader from './BgImageUploader.vue'

export default {
  components: {
    GuideImgUploader,
    CoverImgUploader,
    BgImageUploader
  },
  props: {
    mode: { type: String, default: 'add' },
    mediaForm: { type: Object, default: () => ({}) },
    showDuration: { type: Boolean },
    adSpaceModel: { type: Object },
    guideImgConfig: { type: Object },
    coverImgConfig: { type: Object },
    bgImageConfig: { type: Object }
  },
  data() {
    return {}
  },
  computed: {
    formDisabled() {
      return this.mode === 'edit' && this.mediaForm.checkStatus !== 0
    },
    uploadBoxWidth() {
      const resCount = this.mediaForm.resolutionList.length
      if (resCount <= 4) {
        return resCount * 259 + 10 + 'px'
      }
      return 4 * 259 + 10 + 'px'
    },
    needGuideImg() {
      return this.guideImgConfig.limitSize > 0
    },
    showBgImage() {
      return this.adSpaceModel.bgImage === 1 && this.mediaForm.mediaClassId === 2
    },
    needCoverImg() {
      return (
        this.adSpaceModel.brandIcon &&
        (this.mediaForm.mediaClassId === 2 ||
          (this.mediaForm.mediaClassId === 1 &&
            this.adSpaceModel.spaceNo === 'CCADTV10058'))
      )
    }
  },
  watch: {
    'mediaForm.mediaClassId': {
      handler(newVal) {
        this.clearFiles()
      }
    },
    'mediaForm.spaceId': {
      handler(newVal) {
        this.clearFiles()
      }
    }
  },
  methods: {
    async beforeUploadFile(file, item, index) {
      let errorMessage = ''
      if (file.type === 'image/webp') {
        const hasWebp = this.mediaForm.resolutionList.some((mediaItem, mediaIndex) => {
          return mediaIndex !== index && (mediaItem.isWebp || (mediaItem.webpWidth !== undefined && mediaItem.webpHeight !== undefined))
        })
        if (hasWebp) {
          const message = '无法上传/解析多个webp格式的素材，请分批上传'
          this.$message.error(message)
          return Promise.reject(message)
        }
        const resolution = await getImgResolution(file)
        item.isWebp = true
        item.webpWidth = resolution.width
        item.webpHeight = resolution.height
      } else {
        item.isWebp = false
        item.webpWidth = undefined
        item.webpHeight = undefined
      }
      if (this.mediaForm.mediaClassId === 2 || this.mediaForm.mediaClassId === 4) {
        const isOversize = file.size / 1024 / 1024 < item.limitSize / 1024
        const tsFile = file.name.substring(file.name.length - 3, file.name.length)
        if (['video/mp4'].indexOf(file.type) === -1 && tsFile !== '.ts') {
          errorMessage = '请上传正确的视频格式'
        } else if (!isOversize) {
          let size = item.limitSize / 1024
          errorMessage = `视频大小不能超过${size}M`
        }
      } else {
        const isLimt = file.size / 1024 < item.limitSize
        let index = file.type.indexOf('/')
        let format = file.type.substring(index + 1)
        if (!(item.format.includes(format) || file.type === 'image/jpeg')) {
          errorMessage = `图片只能是 ${item.format} 格式`
        } else if (!isLimt) {
          errorMessage = `图片大小不能超过${item.limitSize}K`
        }
      }
      if (errorMessage !== '') {
        this.$message.error(`【${file.name}】${errorMessage}`)
        return Promise.reject(errorMessage)
      }
    },
    uploadFile(paramsFile, item, index) {
      const self = this
      let fileReader = new FileReader()
      let dataFile = paramsFile.file
      item.status = 'uploading'
      fileReader.readAsBinaryString(dataFile)
      // 文件读取完毕之后的处理
      fileReader.onload = function (e) {
        let spark = new SparkMD5()
        item.md5 = spark.appendBinary(e.target.result).end()
        item.percentage = 0
        item.intervalId = setInterval(() => {
          if (item.percentage < 99) {
            item.percentage += 5
          }
        }, 1560)
        self.requestUpload(paramsFile, item, index)
      }
    },
    requestUpload(paramsFile, item, index) {
      this.$service
        .uploadFile({
          file: paramsFile.file,
          md5: item.md5,
          spaceId: this.mediaForm.spaceId,
          mediaClassId: this.mediaForm.mediaClassId,
          width: item.webpWidth,
          height: item.webpHeight,
          widthLimit: item.width,
          heightLimit: item.height,
        })
        .then(res => {
          if (res.code === 0) {
            item.url = res.data.mediaIconUrl
            item.mediaIcon = res.data.mediaIcon
            item.originalMediaPath = res.data.originalMediaPath
            if (res.data.duration) {
              if (this.showDuration && this.mediaForm.mediaClassId === 1) {
                this.mediaForm.duration = res.data.duration
              }
              item.duration = res.data.duration
            }
            item.status = 'success'
          } else {
            this.$message.error(res.message)
            item.status = 'error'
            this.removeFile(item, index)
          }
          window.clearInterval(item.intervalId)
        })
        .catch(e => {
          this.removeFile(item, index)
          window.clearInterval(item.intervalId)
        })
    },
    clearFiles() {
      const uploadRef = this.$refs.uploader
      if (uploadRef && uploadRef.length) {
        uploadRef.forEach(item => item.clearFiles())
      }
    },
    removeFile(item, index) {
      const uploadRef = this.$refs.uploader
      if (uploadRef.length > index) {
        uploadRef[index].clearFiles()
      }
      item.url = ''
      item.mediaIcon = ''
      item.originalMediaPath = ''
      item.duration = undefined
      item.isWebp = false
      item.webpWidth = undefined
      item.webpHeight = undefined
      item.status = 'none'
      item.percentage = 0
    },
    handleReUpload(item, index) {
      const uploadRef = this.$refs.uploader
      if (uploadRef.length > index) {
        this.removeFile(item, index)
        uploadRef[index].$refs['upload-inner'].$refs.input.click()
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.upload-box
  position relative
  box-sizing border-box
  display flex
  flex-flow row wrap
  gap 10px
  margin 10px 0 20px 120px
  padding 28px 10px 10px
  border 1px solid #c0ccda
  border-radius 4px
  .res-uploader
    width 248px
    height 190px
    margin 0 0 10px 0
    >>>div.el-upload.el-upload--picture-card
      padding 0
      width 248px
      height 190px
    >>>.el-upload-list
      height
    >>>.el-upload-list__item
      width 248px!important
      height 190px!important
      border none
      border-radius 0
    &.exist-img >>>div.el-upload.el-upload--picture-card
      display none
    &.uploading >>>div.el-upload.el-upload--picture-card
      display none
    &.is-disabled >>>.el-upload-list__item-actions
      display none
.image-wrapper
  box-sizing border-box
  border 1px solid #c0ccda
  border-radius 4px
  padding 10px
  height 190px
.image-box
  display flex
  position relative
  flex-grow 1
  height 138px
  .el-image
    height 138px
    padding 0
    .error-icon
      display flex
      justify-content center
      align-items center
      height 100%
  .image-desc
    font-size 12px
    color #999
  .el-upload-list__item-actions
    border 0
    height 138px
    .el-progress
      width 100px
      >>>.el-progress__text
        color #fff
  .el-upload-list__item-delete
    margin 0 12px
    &:hover
      color #f78400
.upload-btn
  display flex
  flex-flow column nowrap
  padding-top 60px
  border-radius 6px
  height 125px
  line-height 22px
  font-size 12px
  color #999
  background-color #fff
  .el-icon
    color #f78400
  p
    margin 4px 0
    word-break break-all
.box-type
  position absolute
  top 0
  left 0
  width 60px
  height 18px
  line-height 18px
  text-align center
  font-size 12px
  color #fff
  background-color #f78400
  border-radius 4px 0
.extra-upload
  display flex
  flex-flow row nowrap
  gap 10px
</style>
